<template>
  <div class="main">
    <div class="search">
      <el-button size="mini" type="primary" @click="openAddPay">新增</el-button>
      <div>
        <!-- 新增收款 -->
        <el-dialog
          title="新增收款"
          :visible.sync="dialogFormVisible"
          width="650px"
          :close-on-click-modal="false"
        >
          <div class="content">
            <el-form ref="form" :model="form" label-width="120px" size="small">
              <el-form-item label="收款方式:">
                <el-select v-model="value" placeholder="请选择收款方式" style="width:100%;">
                  <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="收款账号:">
                <el-input class="oinput" size="small" v-model="name" placeholder="请输入收款账号"></el-input>
              </el-form-item>
              <el-form-item label="AppName:">
                <el-input class="oinput" size="small" v-model="appname" placeholder="请输入AppName"></el-input>
              </el-form-item>
              <el-form-item label="Client Id:">
                <el-input class="oinput" size="small" v-model="clientid" placeholder="请输入Client Id"></el-input>
              </el-form-item>
              <el-form-item label="Secret:">
                <el-input class="oinput" size="small" v-model="secret" placeholder="请输入Secret"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="addPayment">确 定</el-button>
            <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <div class="BigContent">
      <div class="itemNav">
        <span>
          <el-checkbox v-model="allChecked" @change="allChenkedChange"></el-checkbox>
        </span>
        <span>序号</span>
        <span>AppName</span>
        <span>收款方式</span>
        <span>收款账号</span>
        <span>创建时间</span>
        <span>操作</span>
      </div>
      <div
        class="item"
        v-for="(item,index) in payAccountList.page"
        :key="item.id"
        @click="openEditPayAccount(item.id)"
      >
        <span @click.stop>
          <el-checkbox v-model="item.isFlag" @change="(e)=>singleChecked(e,item.id)"></el-checkbox>
        </span>
        <span>{{ index+1 }}</span>
        <span @click.stop>{{ item.appname }}</span>
        <span>{{ 'paypal' }}</span>
        <span @click.stop>{{ item.name }}</span>
        <span @click.stop>{{ item.time }}</span>
        <span>
          <!-- <span>修改</span>
          <span>|</span>-->
          <span @click.self="removePayAccount(item.id)">删除</span>
        </span>
      </div>

      <!-- 修改收款 -->
      <el-dialog
        title="修改收款"
        :visible.sync="dialogFormVisible2"
        width="650px"
        :close-on-click-modal="false"
      >
        <div class="content">
          <el-form ref="form" :model="form" label-width="120px" size="small">
            <el-form-item label="收款方式:">
              <el-select v-model="value" placeholder="请选择收款方式" style="width:100%;">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="AppName:">
              <el-input class="oinput" size="small" v-model="appname" placeholder="请输入AppName"></el-input>
            </el-form-item>
            <el-form-item label="Client Id:">
              <el-input class="oinput" size="small" v-model="clientid" placeholder="请输入Client Id"></el-input>
            </el-form-item>
            <el-form-item label="Secret:">
              <el-input class="oinput" size="small" v-model="secret" placeholder="请输入Secret"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" type="primary" @click="confirmEditPay">确 定</el-button>
          <el-button size="small" @click="dialogFormVisible2 = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 分页 -->
      <div class="pag">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-count="payAccountList.pnum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="size"
          :total="payAccountList.total"
          @current-change="pageChange"
          @size-change="sizeChange"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  addPayNum,
  getPayAccount,
  editPayAccount,
  getPayaccDetail
} from "../../service";
export default {
  data() {
    return {
      dialogFormVisible: false,
      dialogFormVisible2: false,
      allChecked: false,
      form: {
        name: ""
      },
      options: [
        {
          value: "选项1",
          label: "paypal"
        }
      ],
      value: "paypal",
      name: "", //收款账号
      appname: "", //appname
      clientid: "", //clientid
      secret: "", //secret
      payAccountList: {}, //收款账号列表数据
      payid: null, //收款账号id
      pageNum: 1, //分页的当前页数
      size: 20 //每页显示条数，默认显示20条每页
    };
  },
  created() {
    this.getPayAccountList();
  },
  methods: {
    //确定添加收款账号
    addPayment() {
      let params = {
        name: this.name,
        appname: this.appname,
        clientid: this.clientid,
        secret: this.secret
      };
      addPayNum(params).then(res => {
        if (res.data.code === 0) {
          this.dialogFormVisible = false;
          this.$message({
            message: "新增收款账号成功!",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getPayAccountList();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取收款设置列表数据
    getPayAccountList(p = 1) {
      let params = {
        p,
        size: this.size
      };
      getPayAccount(params).then(res => {
        if (res.data.code === 0) {
          this.payAccountList = res.data.result;
          this.payAccountList.page.map((item, i) => {
            item.isFlag = false;
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 分页
    pageChange(p) {
      this.pageNum = p;
      this.getPayAccountList(p);
    },
    // 分页的每页条数发生改变
    sizeChange(val) {
      this.size = val;
      this.getPayAccountList();
    },
    // 打开新增收款账号
    openAddPay() {
      this.name = "";
      this.appname = "";
      this.clientid = "";
      this.secret = "";
      this.dialogFormVisible = true;
    },
    // 打开修改收款账号
    openEditPayAccount(id) {
      this.payid = id;
      let params = { id };
      getPayaccDetail(params).then(res => {
        this.dialogFormVisible2 = true;
        if (res.data.code === 0) {
          this.appname = res.data.result.appname;
          this.clientid = res.data.result.clientid;
          this.secret = res.data.result.secret;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 确定修改收款账号
    confirmEditPay() {
      let params = {
        id: this.payid,
        opt: 3,
        name: this.name,
        appname: this.appname,
        clientid: this.clientid,
        secret: this.secret
      };
      editPayAccount(params).then(res => {
        if (res.data.code === 0) {
          this.dialogFormVisible2 = false;
          this.$message({
            message: "收款账号修改成功",
            type: "success",
            duration: 1000,
            onClose: () => {
              this.getPayAccountList(this.pageNum);
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 删除收款账号
    removePayAccount(id) {
      let params = id;
      this.$confirm("确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      })
        .then(() => {
          let params = { id, opt: 2 };
          editPayAccount(params).then(res => {
            if (res.data.code === 0) {
              this.$message({
                message: "删除成功!",
                type: "success",
                duration: 1000,
                onClose: () => {
                  this.getPayAccountList(this.pageNum);
                }
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 点击改变单选
    singleChecked(e, id) {
      let arr = JSON.parse(JSON.stringify(this.payAccountList.page));
      arr.map((item, i) => {
        if (item.orderno === id) {
          this.$set(item, "isFlag", e);
        }
      });
      this.payAccountList.page = JSON.parse(JSON.stringify(arr));
      this.isAllChecked();
    },
    // 单选改变全选
    isAllChecked() {
      let flag = true;
      this.payAccountList.page.map((item, i) => {
        if (item.isFlag === false) {
          flag = false;
        }
      });
      this.allChecked = flag;
    },
    // 全选改变单选
    allChenkedChange(e) {
      let arr = JSON.parse(JSON.stringify(this.payAccountList.page));
      arr.map((item, i) => {
        arr[i].isFlag = e;
      });
      this.payAccountList.page = JSON.parse(JSON.stringify(arr));
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.main {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  //   height: 100%;
  box-sizing: border-box;
  padding: 20px;
  > .nav {
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 50px;
    border-bottom: 1px solid rgba(235, 237, 248, 1);
    padding-left: 20px;
  }
  .oinput {
    // width: 300px;
  }
  > .content {
    padding-left: 10%;
    padding-top: 30px;
  }
  .btns {
    text-align: center;
    margin-bottom: 50px;
    margin-top: 20px;
  }
}
// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item {
  margin-bottom: 6px;
}
/deep/ .el-upload.el-upload--text {
  border: 1px dashed #e6e6e6;
}
.BigContent {
  .itemNav,
  .item {
    padding-left: 18px;
    &:hover {
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 6%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 18%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 18%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 24%;
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 16%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 14%;
    }
  }
  .itemNav {
    margin-bottom: 10px;
    &:hover {
      background-color: #fff;
    }
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover {
      cursor: pointer;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(7) {
      > span:nth-child(1),
      > span:nth-child(3) {
        color: #1980ff;
        &:hover {
          cursor: pointer;
        }
      }
      > span:nth-child(2) {
        display: inline;
        margin: 4px;
        color: #e6e6e6;
      }
      /deep/ .el-dropdown {
        width: 30px;
        span {
          color: #1980ff;
        }
      }
      > .more {
        display: inline;
      }
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.search {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  > div {
    display: flex;
    > div {
      margin-right: 20px;
    }
  }
  > div:last-child {
    margin-right: 0px;
  }
  .searchInput {
    width: 200px;
    border-radius: 0px;
    /deep/ .el-input__inner {
      border-radius: 4px;
    }
  }
  .searchBtn {
    height: 40px;
    background: rgba(0, 119, 255, 1);
    border-radius: 0px 3px 3px 0px;
  }
}
.dialog-footer {
  text-align: center;
}
</style>